import styled from '@emotion/styled';
import { fonts } from '@theme/fontsCustomer';

export const ErrorText = styled.span`
  color: ${({ theme }) => theme.colors['text-red-light']};
  ${fonts.Body4};
`;
